import React, { useState } from 'react';

import lang from '../../lib/language';

import { useIsMobile } from '../../hooks';
import Button from '../../shared_components/Button/Button';
import { ButtonTypesEnum } from '../../shared_components/Button/Button.types';
import { BaseModal, MobileDrawer } from '../index';

import styles from './HighLowLimitPriceAlert.module.scss';

type Props = {
  isBuyOrder: boolean;
  toggleModal: () => void;
  processModal: () => void;
}

const HighLowLimitPriceAlert = ({ toggleModal, processModal, isBuyOrder }: Props) => {
  const { isMobile } = useIsMobile();
  const [isOpen, setIsOpen] = useState<boolean>(true);

  const handleClose = () => setIsOpen(false);

  const renderContent = () => (
    <>
      <div className={styles.text}>
        <div>
          {lang.webTradingHighLowLimitPriceAlertDescription(
            isBuyOrder ? lang.webTradingHighLowLimitPriceAlertHigher() : lang.webTradingHighLowLimitPriceAlertLower(),
          )}
        </div>
      </div>
      <div className={styles.buttonsWrapper}>
        <Button
          fullWidth
          biggerFontSize
          onClick={processModal}
        >
          {lang.commonContinueButton()}
        </Button>
        <Button
          variant={ButtonTypesEnum.Secondary}
          fullWidth
          biggerFontSize
          onClick={handleClose}
        >
          {lang.webTradingEditPriceButton()}
        </Button>
      </div>
    </>
  );

  if (isMobile) {
    return (
      <MobileDrawer
        isOpen={isOpen}
        title={lang.webTradingHighLowLimitPriceAlert(
          isBuyOrder ? lang.webTradingHighLowLimitPriceAlertHigh() : lang.webTradingHighLowLimitPriceAlertLow(),
        )}
        onClose={toggleModal}
      >
        {renderContent()}
      </MobileDrawer>
    );
  }

  return (
    <BaseModal isOpen={isOpen} toggle={toggleModal}>
      <div className={styles.title}>
        {lang.webTradingHighLowLimitPriceAlert(
          isBuyOrder ? lang.webTradingHighLowLimitPriceAlertHigh() : lang.webTradingHighLowLimitPriceAlertLow(),
        )}
      </div>
      {renderContent()}
    </BaseModal>
  );
};

export default HighLowLimitPriceAlert;
